export default __webpack_public_path__ + "static/media/mu.83a1ff17.svg";